const base = 'Universitätsklinikum Frankfurt';
const divider = ' | ';
export const routes = [
    {
        path: '*',
        redirect: '/',
    },{
        path: '/',
        name: 'Startseite',
        component: () => import('@/views/Startseite.vue'),
        meta: {
            title: base,
        },
    },{
        path: '/impressum',
        name: 'Impressum',
        component: () => import('@/views/Impressum.vue'),
        meta: {
            title: 'Impressum' + divider + base,
        },
    },{
        path: '/datenschutz',
        name: 'Datenschutz',
        component: () => import('@/views/Datenschutz.vue'),
        meta: {
            title: 'Datenschutz' + divider + base,
        },
    },{
        path: '/fachabteilungen',
        name: 'Medizinische Fachabteilungen',
        component: () => import('@/views/Fachabteilungen.vue'),
        meta: {
            title: 'Medizinische Fachabteilungen' + divider + base,
        },
    },{
        path: '/notfall',
        name: 'Notfall',
        component: () => import('@/views/Notfall.vue'),
        meta: {
            title: 'Notfall' + divider + base,
        },
    }
]
